import React from "react";
import Card from "components/card";

function DeviceDetails({ deviceDetails }) {
  // Safety check to prevent crashes if data is missing or loading
  if (!deviceDetails || !deviceDetails.deviceDetailsTable) return null;

  return (
    <Card extra="rounded-[20px] p-3 relative h-full">
      <div className="flex flex-row justify-between px-3 pt-2">
        <div>
          <h4 className="mb-3 text-lg font-bold text-navy-700 dark:text-white">
            {deviceDetails.displayName}
          </h4>
        </div>
      </div>
      
      {deviceDetails.AssetImg && (
        <div className="mb-4 flex justify-center">
          <img src={deviceDetails.AssetImg} alt="Asset" className="max-h-32 object-contain" />
        </div>
      )}

      <div className="ml-4 flex flex-col w-auto space-y-2 pb-4">
        {deviceDetails.deviceDetailsTable.map((data, index) => {
          
          // --- THE INTERCEPTOR LOGIC ---
          // Default to the original value from the GET request
          let displayValue = data.value;

          // If the row is "Last Update" and we have a fresh socket ping, override it
          if (data.name.includes("Last Update") && deviceDetails.networkts) {
            displayValue = deviceDetails.networkts;
          }
          
          // If the row is "Location Type" and the socket calculated a new string, override it
          if (data.name.includes("Location Type") && deviceDetails.displayLocationType) {
            displayValue = deviceDetails.displayLocationType;
          }

          return (
            <div key={index} className="flex flex-row">
              <p className="mr-2 font-dm text-sm font-medium text-gray-600 w-32 shrink-0">
                {data.name}
              </p>
              <p className="font-dm text-sm font-bold text-navy-700 dark:text-white break-words">
                {displayValue}
              </p>
            </div>
          );
        })}
      </div>
    </Card>
  );
}

export default DeviceDetails;